export namespace BulkAddSlideOverModel {
  export enum ResourceTypeEnum {
    ITEMS = "items",
    LOCATIONS = "locations",
  }
}
